module.exports = __webpack_public_path__ + "static/media/trade-federation.7ccfa25e.svg";